module.exports = __webpack_public_path__ + "img/Eritrea.df14a128.svg";